<script>
import { mapGetters } from 'vuex';
import config from '@/config';
import TweenMax, {Expo, Power3} from 'gsap/TweenMax';

export default {
  name: 'Death',
  computed: {
    gifStyle() {
      return {
        backgroundImage: `url(${this.gifURL}`
      }
    },
    ...mapGetters({
      hasEnded: 'Sound/hasEnded',
      locale: 'I18n/locale',
    }),
  },
  data() {
    return {
      gifURL: '/assets/tableaux/death/death.gif',
    }
  },
  // watch: {
  //   hasEnded(value) {
  //     if(value === 'deathS') {
  //       this.exit();
  //     }
  //   }
  // },
  mounted() {
    config.ga('mort', this.locale);

    this.$store.dispatch('Interface/SHOW_BUBBLES');
    
    // sound
    this.$store.dispatch('Sound/PLAY', {id: 'deathS'});

    //animation
    TweenMax.from(this.$el.querySelector(".-GIF"), 2, {alpha:0, ease:Expo.easeOut});      
    TweenMax.delayedCall(3.4, this.$store.dispatch, ['Interface/HIDE_BUBBLES'], this.$store);

    TweenMax.delayedCall(13.5, this.exit, null, this);
  },
  methods: {
    exit() {
      TweenMax.to(this.$el, 1, {alpha:0, ease:Power3.easeOut, onComplete: () => {
        
        TweenMax.delayedCall(.25, () => {
          this.$router.push({name:`About${this.locale.toUpperCase()}`});
        });

      }});
    },
  }
}
</script>

<template>
  <div class="Death">
    <div ref="Gif" class="-GIF" :style="gifStyle" />
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Death {
  position: relative;
  width: 100%;
  height: calc(100% - #{$header-height});
  margin: 0px;
  background-color: $c-white;

  @include ipad(landscape) {
    display: none;
  }
}

.-GIF {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: {
    repeat: no-repeat;
    size: cover;
    position: center center;
  }
}

</style>
